import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OriginsRoutingModule } from './origins-routing.module';
import { OriginsListComponent } from './origins-list/origins-list.component';
import { OriginsDetailComponent } from './origins-detail/origins-detail.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { CoreModule } from 'src/app/core/core.module';


@NgModule({
  declarations: [OriginsListComponent, OriginsDetailComponent],
  imports: [
    CommonModule,
    OriginsRoutingModule,
    ButtonModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    CoreModule,
    CardModule,
    FontAwesomeModule,
    InputTextareaModule,
    DropdownModule,
    CalendarModule,
    SplitButtonModule,
    TimelineModule
  ],
  exports:[
    OriginsListComponent,
    OriginsDetailComponent
  ]
})
export class OriginsModule { }
